import { enableNetwork } from 'firebase/firestore'
import { useEffect } from 'react'
import { db } from 'api/Firebase/firebase-init'

/**
 * Reconnects Firestore when the user returns to the app after the phone screen
 * was locked or the browser tab was backgrounded.
 *
 * All existing onSnapshot listeners survive the network pause — Firebase keeps
 * them registered internally. Calling enableNetwork() is enough to resume them.
 *
 * We do NOT call disableNetwork() when hidden: the OS freezes the JS thread
 * when the screen locks anyway, so the call would never reach Firestore in the
 * locked state; and actively disconnecting on every tab-switch would cause
 * unnecessary subscription gaps.
 */
export const useFirestoreReconnect = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        enableNetwork(db).catch(err => console.warn('Firestore enableNetwork failed', err))
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])
}
